import { Login } from "./Login";
import Logout from "./Logout";
import CustomerConfiguration from "./MasterData/Customer/CustomerConfiguration";
import UserConfiguration from "./MasterData/User/UserConfiguration";
import ZoneConfiguration from "./MasterData/Zone/ZoneConfiguration";
import ProductConfiguration from "./MasterData/Product/ProductConfiguration";
import PalletConfiguration from "./MasterData/Pallet/PalletConfiguration";
import PalletDetail from "./MasterData/Pallet/PalletDetail";
import WarehouseConfiguration from "./MasterData/Warehouse/WarehouseConfiguration";
import WarehouseDetail from "./MasterData/Warehouse/WarehouseDetail";
import ProductDetail from "./MasterData/Product/ProductDetail";
import ZoneDetail from "./MasterData/Zone/ZoneDetail";
import CustomerDetail from "./MasterData/Customer/CustomerDetail";
import UserDetail from "./MasterData/User/UserDetail";
import ReceiveDocument from "./Operator/ReceiveDocument";
import ReceiveDetail from "./Operator/ReceiveDetail";
import LoadingOrderDetail from "./Operator/LoadingOrderDetail";
import LoadingOrderDocument from "./Operator/LoadingOrderDocument";
import PrepareDetail from "./Operator/PrepareDetail";
import PrepareDocument from "./Operator/PrepareDocument";
import DeliveryOrderDetail from "./Operator/DeliveryOrderDetail";
import DeliveryOrderDocument from "./Operator/DeliveryOrderDocument";
import ProductionPlan from "./Operator/ProductionPlan";
import NotFound from "./Operator/NotFound";
import AuditTrail from "./Tracking/AuditTrail";
import WarehouseDetailReport from "./Report/WarehouseDetailReport";
import PackingReport from "./Report/PackingReport";
import ForkliftProductivityReport from "./Report/ForkliftProductivityReport";
import SlowMovingStockReport from "./Report/SlowMovingStockReport";
import BarcodeTracking from "./Tracking/BarcodeTracking";
import DeliveryDetailReport from "./Report/DeliveryDetailReport";
import Bay4SReport from "./Report/Bay4SReport";
import Setting from "./Setting";
import CycleCountReport from "./Report/CycleCountReport";
import QRCodeBank from "./QRCodeBank";
import MaterialRequirement from "./Operator/MateriaRequirement";
import MaterialRequirementsDetail from "./Operator/MaterialRequirementDetail";
import PeriodicCycleCount from "./Operator/PeriodicCycleCount";
import PeriodicCycleCountDetail from "./Operator/PeriodicCycleCountDetail";
import ReturnReport from "./Report/ReturnReport";
import ExportSampleReport from "./Report/ExportSampleReport";
import WarehouseLayout from "./Report/WarehouseLayout";
import Authenticator from "./Authenticator";
import { InProcessCheck } from "./Report/InProcessCheck";
import { InProcessCheckDetail } from "./Report/InProcessCheck/InProgressCheckDetail";
import { ProductGroup } from "./MasterData/ProductGroup"
import { ProductGroupDetail } from "./MasterData/ProductGroup/ProductGroupDetail"

const PAGE = {
  Login,
  Logout,
  Authenticator,
  ProductDetail,
  WarehouseConfiguration,
  WarehouseDetail,
  ProductConfiguration,
  ZoneConfiguration,
  PalletConfiguration,
  CustomerConfiguration,
  UserConfiguration,
  ReceiveDocument,
  ZoneDetail,
  ReceiveDetail,
  CustomerDetail,
  UserDetail,
  LoadingOrderDetail,
  LoadingOrderDocument,
  PrepareDocument,
  PrepareDetail,
  DeliveryOrderDetail,
  DeliveryOrderDocument,
  PalletDetail,
  ProductionPlan,
  NotFound,
  AuditTrail,
  WarehouseDetailReport,
  PackingReport,
  ForkliftProductivityReport,
  SlowMovingStockReport,
  BarcodeTracking,
  DeliveryDetailReport,
  Bay4SReport,
  Setting,
  CycleCountReport,
  QRCodeBank,
  MaterialRequirement,
  MaterialRequirementsDetail,
  PeriodicCycleCount,
  PeriodicCycleCountDetail,
  ReturnReport,
  ExportSampleReport,
  WarehouseLayout,
  InProcessCheck,
  InProcessCheckDetail,
  ProductGroup,
  ProductGroupDetail
};

export default PAGE;
